import { TObituaryImage } from "@/types/obituary";

const ImageComment = ({ url, width, height }: TObituaryImage) => {
  if (url) {
    return (
      <>
        <div className="relative flex w-full justify-center">
          <img
            src={url.replace("/upload", "/upload/h_600/g_auto/f_auto/q_auto/")}
            className="absolute max-h-[380px] w-full object-cover lg:max-h-[600px]"
          />
          <div className="absolute h-full w-full bg-black/80 backdrop-blur"></div>

          <img
            src={url.replace("/upload", "/upload/h_600/g_auto/f_auto/q_auto/")}
            className="relative h-auto max-h-[380px] w-full object-contain lg:max-h-[600px]"
          />
        </div>
      </>
    );
  }
  return <></>;
};

export default ImageComment;
